import {Stack} from "@mui/material";
import React from "react";
import {useParams} from "react-router-dom";
import {OrderStep} from "../../context/order";
import {B2Site} from "../../data/client.gen";
import {OrderBoxes} from "./order-boxes";
import {OrderCheckout} from "./order-checkout";
import {OrderDates} from "./order-dates";

interface OrderFlowProps {
	site: B2Site;
}

export function OrderFlow({site}: OrderFlowProps) {
	const {step} = useParams<{ step: OrderStep }>();

	return (
		<Stack mt={3}>
			{step === "dates" && <OrderDates site={site} />}
			{step === "boxes" && <OrderBoxes site={site} />}
			{step === "checkout" && <OrderCheckout site={site} />}
		</Stack>
	);
}
